
import React from 'react';
import PropTypes from 'prop-types';

export default function IconClose({ className, style, type }) {
  return (
    type === 'thin' ? (
      <svg
        className={className}
        fill="none"
        height="24"
        style={style}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3 5.70997C17.91 5.31997 17.28 5.31997 16.89 5.70997L12 10.59L7.10997 5.69997C6.71997 5.30997 6.08997 5.30997 5.69997 5.69997C5.30997 6.08997 5.30997 6.71997 5.69997 7.10997L10.59 12L5.69997 16.89C5.30997 17.28 5.30997 17.91 5.69997 18.3C6.08997 18.69 6.71997 18.69 7.10997 18.3L12 13.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L13.41 12L18.3 7.10997C18.68 6.72997 18.68 6.08997 18.3 5.70997Z"
        />
      </svg>
    ):(
      <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_5868_13232)">
          <rect fill="white" height="32" rx="16" width="32" x="8" y="6"/>
          <path d="M17.5078 15.6558L17.5771 15.5773C17.8775 15.2769 18.3502 15.2538 18.6771 15.508L18.7556 15.5773L23.9997 20.8208L29.2438 15.5773C29.5692 15.2519 30.0968 15.2519 30.4223 15.5773C30.7477 15.9028 30.7477 16.4304 30.4223 16.7558L25.1788 21.9999L30.4223 27.244C30.7227 27.5444 30.7458 28.0171 30.4916 28.344L30.4223 28.4225C30.1219 28.7229 29.6492 28.746 29.3223 28.4918L29.2438 28.4225L23.9997 23.1791L18.7556 28.4225C18.4302 28.7479 17.9025 28.7479 17.5771 28.4225C17.2516 28.0971 17.2516 27.5694 17.5771 27.244L22.8205 21.9999L17.5771 16.7558C17.2767 16.4554 17.2536 15.9827 17.5078 15.6558L17.5771 15.5773L17.5078 15.6558Z" fill="#25282B"/>
        </g>
        <defs>
          <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="48" id="filter0_d_5868_13232" width="48" x="0" y="0">
            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
            <feOffset dy="2"/>
            <feGaussianBlur stdDeviation="4"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
            <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_5868_13232"/>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow_5868_13232" mode="normal" result="shape"/>
          </filter>
        </defs>
      </svg>

    )
  );
}

IconClose.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.string
};
